export default __webpack_public_path__ + "static/media/Group-146-Yono-mitc.83ab698e.png";